import { withInstall } from '@pit-element-plus/utils'
import Segmented from './src/segmented.vue'

export const ElSegmented = withInstall(Segmented)
export default ElSegmented

export * from './src/segmented'
